// export const API_BASE_URL = "http://localhost:8100";
export const API_BASE_URL = "https://cce.astanait.edu.kz";
// export const CLIENT_BASE_URL = "http://localhost:3000";
export const CLIENT_BASE_URL = "https://cce.astanait.edu.kz";
export const NCA_LAYER_URL = "wss://127.0.0.1:13579/";